import { useMutation, gql } from '@apollo/client';
import {
  CadastrarHorarioMutation,
  CadastrarHorarioMutationVariables,
} from './__generated__/CadastrarHorarioMutation';

const CADASTRAR_HORARIO_MUTATION = gql`
  mutation CadastrarHorarioMutation($hora_inicio: String!, $hora_fim: String!) {
    cadastrarHorario(input: { hora_inicio: $hora_inicio, hora_fim: $hora_fim }) {
      id_horario
      hora_inicio
      hora_fim
    }
  }
`;

const useCadastrarHorarioMutation = () => {
  return useMutation<CadastrarHorarioMutation, CadastrarHorarioMutationVariables>(
    CADASTRAR_HORARIO_MUTATION
  );
};

export { useCadastrarHorarioMutation };
